module.exports = __webpack_public_path__ + "static/media/egyptian3.a10d0558.jpeg";